import Guid from "common/values/guid/guid";

export interface DocumentTopicJSON {
  entityClass?: string;
  entityId?: string;
  context?: string;
}

/** 
    * Represents a topic that a document can be associated with.
    * Must have at least one of the properties provided.
    * If entityId is provided, entityClass must be provided.
*/
export default class DocumentTopic {
  entityClass?: string;
  entityId?: Guid;
  context?: string;

  constructor(entityClass?: string, entityId?: Guid, context?: string) {
    if ((!entityClass || entityClass.length === 0)
      && (!context || context.length === 0)
      && !entityId) {
      throw new Error("At least one of the properties must be provided");
    }
    if (entityId && (!entityClass || entityClass.length === 0)) {
      throw new Error("entityClass must be provided when entityId is provided");
    }

    this.entityClass = entityClass;
    this.entityId = entityId;
    this.context = context;
  }

  public toJSON(): DocumentTopicJSON {
    return {
      entityClass: this.entityClass,
      entityId: this.entityId?.value,
      context: this.context
    };
  }

  public static fromJSON(json: DocumentTopicJSON): DocumentTopic {
    const entityId = json.entityId ? Guid.fromJSON(json.entityId) : undefined;
    return new DocumentTopic(json.entityClass, entityId, json.context);
  }
}
